import { QuestionCircleOutlined } from '@ant-design/icons'
import { Col, Form, message, Switch, Tooltip } from 'antd'
import { useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { usePTOV2Context } from 'context/pto-v2-context-provider'
import { logError } from 'utils/logger'

/** Toggle send gift for a PTO (PATCH /admin/tokenize-gift/:id) */
const ButtonSendGift = ({ edit }: { edit: boolean }) => {
  const { ptoDetail, getPTODetail } = usePTOV2Context()
  const [loading, setLoading] = useState(false)

  const handleChange = async (checked: boolean) => {
    try {
      setLoading(true)
      await AppAdmin.updateSendGiftStatus(ptoDetail._id, checked ? 1 : 0)
      message.success(`${checked ? 'Enable' : 'Disable'} send gift successfully`)
      getPTODetail()
    } catch (error: any) {
      logError('Error updating send gift status: ', error)
      message.error(error?.response?.data?.message || 'Failed to update send gift status')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Col span={6}>
      <Form.Item
        label={
          <>
            Send Gift
            <Tooltip
              title={
                <div className="tooltip-box">
                  <p className="tooltip-text">
                    Toggle the switch to allow sending this PTO as a gift. When the switch is{' '}
                    <strong>ON</strong>, send gift is enabled. When the switch is{' '}
                    <strong>OFF</strong>, send gift is disabled.
                  </p>
                </div>
              }
              placement="right"
            >
              <QuestionCircleOutlined className="tooltip-icon" />
            </Tooltip>
          </>
        }
      >
        <Switch
          checked={ptoDetail?.sendGiftStatus === 1}
          disabled={!edit || loading}
          onChange={handleChange}
        />
      </Form.Item>
    </Col>
  )
}

export default ButtonSendGift
